import { render, staticRenderFns } from "./LinkDestroyComponent.vue?vue&type=template&id=e38ffa02&scoped=true"
import script from "./LinkDestroyComponent.vue?vue&type=script&lang=js"
export * from "./LinkDestroyComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e38ffa02",
  null
  
)

export default component.exports